import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill-rule=\"evenodd\" stroke=\"#171717\" stroke-linecap=\"round\" d=\"M12 2.5a9.5 9.5 0 0 1 9.5 9.5 9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2.5 12 9.5 9.5 0 0 1 12 2.5Z\" clip-rule=\"evenodd\"></path><path stroke=\"#171717\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M12 11v6\"></path><path fill=\"#171717\" fill-rule=\"evenodd\" d=\"M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0\" clip-rule=\"evenodd\"></path><path fill-rule=\"evenodd\" stroke=\"#171717\" stroke-linecap=\"round\" d=\"M12 2.5a9.5 9.5 0 0 1 9.5 9.5 9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2.5 12 9.5 9.5 0 0 1 12 2.5Z\" clip-rule=\"evenodd\"></path><path stroke=\"#171717\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M12 11v6\"></path>", 5)
  ]))]))
}
export default { render: render }